module.exports = __webpack_public_path__ + "img/geodir-alicorp-logo.55b17e58.png";